import useSWR from "swr"
import {API_USERS} from "../constants/apiUrls"

export default function useUser(userId) {
    const {data, mutate, error} = useSWR(`${API_USERS}/${userId}`)
    return {
        user: data,
        mutateUser: mutate,
        isLoadingUser: !error && !data,
        isErrorUser: error
    }
}